import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalState {
  weekStart: string;
  companyName: string;
  companyDomain: string;
  companyStreet: string;
  companyCity: string;
  companyState: string;
  companyZip: string;
  companyPhone: string;
  companyRepresentativeFirstName: string;
  companyRepresentativeLastName: string;
  companyRepresentativeEmail: string;
}

const initialState: GlobalState = {
  weekStart: 'Mon',
  companyName: '',
  companyDomain: '',
  companyStreet: '',
  companyCity: '',
  companyState: '',
  companyZip: '',
  companyPhone: '',
  companyRepresentativeFirstName: '',
  companyRepresentativeLastName: '',
  companyRepresentativeEmail: '',
};

export const companySetupSlice = createSlice({
  name: 'companySetup',
  initialState,
  reducers: {
    setWeekStart: (state, action: PayloadAction<string>) => {
      state.weekStart = action.payload;
    },
    setRepFirstName: (state, action: PayloadAction<string>) => {
      state.companyRepresentativeFirstName = action.payload;
    },
    setRepLastName: (state, action: PayloadAction<string>) => {
      state.companyRepresentativeLastName = action.payload;
    },
    setRepEmail: (state, action: PayloadAction<string>) => {
      state.companyRepresentativeEmail = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string>) => {
      state.companyName = action.payload;
    },
    setCompanyDomain: (state, action: PayloadAction<string>) => {
      state.companyDomain = action.payload;
    },
    setCompanyStreet: (state, action: PayloadAction<string>) => {
      state.companyStreet = action.payload;
    },
    setCompanyCity: (state, action: PayloadAction<string>) => {
      state.companyCity = action.payload;
    },
    setCompanyState: (state, action: PayloadAction<string>) => {
      state.companyState = action.payload;
    },
    setCompanyZip: (state, action: PayloadAction<string>) => {
      state.companyZip = action.payload;
    },
    setCompanyPhone: (state, action: PayloadAction<string>) => {
      state.companyPhone = action.payload;
    },
    resetState: (state) => {
      state.weekStart = 'Mon';
      state.companyName = '';
      state.companyDomain = '';
      state.companyStreet = '';
      state.companyCity = '';
      state.companyState = '';
      state.companyZip = '';
      state.companyPhone = '';
      state.companyRepresentativeFirstName = '';
      state.companyRepresentativeLastName = '';
      state.companyRepresentativeEmail = '';
    },
  },
});

export const {
  setRepEmail,
  setRepLastName,
  setRepFirstName,
  setCompanyName,
  setCompanyDomain,
  setCompanyStreet,
  setCompanyCity,
  setCompanyState,
  setCompanyZip,
  setCompanyPhone,
  resetState,
  setWeekStart,
} = companySetupSlice.actions;

export default companySetupSlice.reducer;
